import React, { Component, Fragment } from 'react'
import gql from 'graphql-tag'
import Grid from '@material-ui/core/Grid'
import {
  withStyles,
  MuiThemeProvider,
  createMuiTheme
} from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import TextField from '@material-ui/core/TextField'
import withSharedSnackbar from '../../../HOCs/withSharedSnackbar'
import getAccountType from '../../../../utils/getAccountType'
import { withApollo } from 'react-apollo'
import { CircularProgress } from '@material-ui/core'
import axios from 'axios'
import FileSaver from 'file-saver'
import moment from 'moment'
import BillingDetailsProformaInvoice from './BillingDetailsProformaInvoice'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import MenuItem from '@material-ui/core/MenuItem'
import PaymentMethod from '../../ViewSubscription/PaymentMethod'
import Select from '@material-ui/core/Select'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import MUIDataTable from 'mui-datatables'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'

const GET_PI_INFO = gql`
  query($id: Int!) {
    getPIAndInvoiceDetail(id: $id) {
      noOfSubscriptions
      paymentMasterDetails {
        id
        invoiceId
        serviceRemarks
        paidMoney
        invoiceAmountWithGST
        paymentStatus
      }
      clientDetails {
        id
        clientName
        wallet
        simWallet
      }
      partnerDetails {
        id
        businessName
        wallet
        simWallet
      }
      billingDetails {
        totalAmountToBePaidGST
        hardwareBillDetails {
          quantity
          amount
          amountGST
          amountPaidGST
          amountToBePaidGST
          creditDate
        }
        softwareBillDetails {
          quantity
          amount
          amountGST
          amountPaidGST
          amountToBePaidGST
          creditDate
        }
        accessoryBillDetails {
          quantity
          amount
          amountGST
          amountPaidGST
          amountToBePaidGST
          creditDate
        }
        simBillDetails {
          quantity
          amount
          amountGST
          amountPaidGST
          amountToBePaidGST
          creditDate
        }
      }
      subscriptionBillDetails {
        invoiceAmount
      }
      paymentHitoryDetails {
        noOfSubscription
        accountRemarks
      }
    }
  }
`

const MAKE_PAYMENT = gql`
  mutation makePayment(
    $paymentId: Int!
    $totalAmountPaid: Int!
    $simAmountPaid: Int!
    $softwareAmountPaid: Int!
    $accessoryAmountPaid: Int!
    $hardwareAmountPaid: Int!
    $accountRemarks: String
    $paymentMode: paymentMode!
    $paymentStatus: Int!
    $bankName: String
    $referenceNumber: String
    $chequeDate: String
    $simExpectedDate: String
    $softwareExpectedDate: String
    $hardwareExpectedDate: String
    $accessoryExpectedDate: String
  ) {
    makePayment(
      paymentId: $paymentId
      totalAmountPaid: $totalAmountPaid
      simAmountPaid: $simAmountPaid
      softwareAmountPaid: $softwareAmountPaid
      accessoryAmountPaid: $accessoryAmountPaid
      hardwareAmountPaid: $hardwareAmountPaid
      accountRemarks: $accountRemarks
      paymentMode: $paymentMode
      paymentStatus: $paymentStatus
      bankName: $bankName
      referenceNumber: $referenceNumber
      chequeDate: $chequeDate
      simExpectedDate: $simExpectedDate
      accessoryExpectedDate: $accessoryExpectedDate
      softwareExpectedDate: $softwareExpectedDate
      hardwareExpectedDate: $hardwareExpectedDate
    )
  }
`

const CREATE_INVOICE = gql`
  mutation(
    $id: Int!
    $paymentStatus: Int!
    $invoiceAmount: Int
    $discount: Int
    $serviceRemarks: String
    $accountRemarks: String
  ) {
    updateAndRaiseInvoice(
      id: $id
      paymentStatus: $paymentStatus
      invoiceAmount: $invoiceAmount
      discount: $discount
      serviceRemarks: $serviceRemarks
      accountRemarks: $accountRemarks
    )
  }
`

const GET_PDF_DOWNLOAD_LINK = gql`
  query($id: Int!, $isInvoice: Boolean!) {
    getInvoiceDownloadDetails(id: $id, isInvoice: $isInvoice)
  }
`

const GET_PI_AND_INVOICE = gql`
  query getPIAndInvoiceDetail($id: Int!) {
    getPIAndInvoiceDetail(id: $id) {
      paymentMasterDetails {
        id
        invoiceId
      }
      paymentHitoryDetails {
        id
        paidMoney
        paymentMode
        referenceNumber
        createdAt
        accountRemarks
        bank
      }
    }
  }
`

const style = theme => ({
  root: {
    padding: theme.spacing.unit * 4,
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary
  },
  iconSmall: {
    fontSize: 20
  },
  selectStyle: {
    margin: theme.spacing.unit,
    minWidth: 250
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    minWidth: 250
  },
  pad: {
    padding: theme.spacing.unit * 2
  },
  redButton: {
    backgroundColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: theme.palette.error.dark
    }
  }
})

const paymentOption = ['CASH', 'ONLINE', 'CHEQUE', 'DD']

const columns = [
  'Payment Id',
  'Payment Made',
  'Mode of Payment',
  'Reference Number',
  'Bank',
  'Date of Payment',
  'Payment Remarks'
]

class CreateProformaInvoice extends Component {
  constructor(props) {
    super(props)
    this.id = this.props.match.params.id
  }

  state = {
    labelWidth: 0,
    piInfo: '',
    paymentType: '',
    invoiceAmount: 0,
    paymentStatus: '',
    discount: 0,
    remarks: '',
    error: true,
    isDownloading: false,
    paymentMode: '',
    paymentId: 0,
    referenceNumber: null,
    bankName: '',
    paidMoney: '',
    accountRemarks: '',
    validation: false,
    hardwarePaymentMade: 0,
    softwarePaymentMade: 0,
    accessoryPaymentMade: 0,
    simPaymentMade: 0,
    totalAmountPaid: 0,
    hardwareBalance: 0,
    softwareBalance: 0,
    accessoryBalance: 0,
    simBalance: 0,
    paymentMadeFieldValidation: false,
    hardwareRemarks: null,
    softwareRemarks: null,
    accessoryRemarks: null,
    simRemarks: null,
    checkDate: null,
    expectedHardwareDueDate: moment().add(1, 'weeks'),
    expectedSoftwareDueDate: moment().add(1, 'weeks'),
    expectedAccessoryDueDate: moment().add(1, 'weeks'),
    expectedSimsDueDate: moment().add(1, 'weeks'),
    approveOrReject: null,
    allInvoiceData: [],
    paymentStatusShow: '',
    saveBtnDisabled: false
  }

  getMuiTheme = () =>
    createMuiTheme({
      overrides: { MUIDataTableToolbar: { root: { display: 'none' } } }
    })

  options = {
    filterType: 'dropdown',
    filter: false,
    search: false,
    download: false,
    print: false,
    disableToolbarSelect: false,
    viewColumns: false,
    selectableRows: false,
    responsive: 'scroll',
    rowsPerPage: 5,
    rowHover: false
    // onRowClick: (rowData, dataIndex, rowIndex) => {
    //   this.props.history.push({
    //     pathname:
    //       '/home/subscriptions' +
    //       '/' +
    //       this.subcriptionIdPartner[dataIndex.dataIndex] +
    //       '/partnerSubscriptionDetail'
    //   })
    // }
  }
  // makePayment = () => {
  //   this.props.history.push({
  //     pathname: '/home/manage/makePayment'
  //   })
  // }

  // handleChangeDiscount = event => {
  //   this.setState(
  //     {
  //       discount: event.target.value,
  //       invoiceAmount: this.state.piInfo.totalPI - event.target.value
  //     },
  //     () => this.checkTotalInvoice()
  //   )
  // }

  // checkTotalInvoice() {
  //   if (
  //     this.state.piInfo.totalPI < this.state.invoiceAmount ||
  //     this.state.invoiceAmount < 0
  //   ) {
  //     this.props.openSnackbar(
  //       'Discount should not be more than Invoice amount!'
  //     )
  //     this.setState({
  //       error: false,
  //       discount: 0,
  //       invoiceAmount: 0
  //     })
  //   }
  // }

  handleChangeRemarks = event => {
    this.setState({ remarks: event.target.value })
  }

  handleSaveMutation = async () => {
    const { data, errors } = await this.props.client.mutate({
      mutation: MAKE_PAYMENT,
      variables: {
        paymentId: parseInt(this.state.paymentId, 10),
        totalAmountPaid: parseInt(this.state.totalAmountPaid, 10),
        simAmountPaid: parseInt(this.state.simPaymentMade, 10),
        softwareAmountPaid: parseInt(this.state.softwarePaymentMade, 10),
        accessoryAmountPaid: parseInt(this.state.accessoryPaymentMade, 10),
        hardwareAmountPaid: parseInt(this.state.hardwarePaymentMade, 10),
        accountRemarks: this.state.accountRemarks,
        paymentMode: this.state.paymentMode,
        paymentStatus: parseInt(this.state.paymentStatus, 10),
        bankName: this.state.bankName,
        referenceNumber: this.state.referenceNumber
          ? this.state.referenceNumber.toString()
          : this.state.referenceNumber,
        chequeDate: moment(parseInt(this.state.checkDate, 10)),
        simExpectedDate: moment(this.state.expectedSimsDueDate)
          .unix()
          .toString(),
        accessoryExpectedDate: moment(this.state.expectedAccessoryDueDate)
          .unix()
          .toString(),
        softwareExpectedDate: moment(this.state.expectedHardwareDueDate)
          .unix()
          .toString(),
        hardwareExpectedDate: moment(this.state.expectedSoftwareDueDate)
          .unix()
          .toString()
      },
      errorPolicy: 'all'
    })
    if (errors) {
      this.props.openSnackbar(errors[0].message, { type: 'error' })
      this.setState({ saveBtnDisabled: false })
    } else if (data.makePayment) {
      this.props.openSnackbar('Successfully Details Saved')
      this.props.history.goBack()
    }
  }

  validateFields = () => {
    let regExValue = new RegExp(/^([a-zA-Z0-9_-]){5,25}$/)
    let regExValueBank = new RegExp(/^[A-Za-z\s]{3,30}$/)
    if (this.state.paymentMode === 'ONLINE') {
      if (
        this.state.referenceNumber !== '' &&
        regExValue.test(this.state.referenceNumber)
      ) {
        this.setState({ validation: true })
        return true
      } else {
        this.props.openSnackbar(
          'Reference Number length Should between 5 to 25 and Alphanumeric'
        )
        this.setState({ validation: false })
        return false
      }
    } else if (this.state.accountRemarks.length > 100) {
      this.props.openSnackbar('Remarks should be less than 100 Characters!')
      return false
    } else if (
      this.state.paymentMode === 'DD' ||
      this.state.paymentMode === 'CHEQUE'
    ) {
      if (!regExValue.test(this.state.referenceNumber)) {
        console.log('reference in valid')
        this.props.openSnackbar(
          'Reference Number length Should between 5 to 25 and Alphanumeric'
        )
        this.setState({ validation: false })
        return false
      } else if (
        !regExValueBank.test(this.state.bankName) ||
        this.state.bankName === null
      ) {
        this.props.openSnackbar(
          'Bank Name length Should be between 3 to 30 and only alphabets'
        )
        this.setState({ validation: false })
        return false
      } else {
        this.setState({ validation: true })
        return true
      }
    } else {
      this.setState({ validation: true })
      return true
    }
  }

  handleSave = () => {
    if (this.validateFields()) {
      this.setState({ saveBtnDisabled: true })
      this.handleSaveMutation()
    }
  }

  handleCancel = loginId => {
    console.log('this.props', this.props)
    this.props.history.goBack()
    // this.props.history.push({
    //   pathname: '/home/manage/admin/InvoiceDetails'
    // })
  }

  // handleReject = async () => {
  //   await this.props.client.mutate({
  //     mutation: CREATE_INVOICE,
  //     variables: {
  //       id: parseInt(this.id, 10),
  //       invoiceAmount: parseInt(this.state.piInfo.totalPI, 10),
  //       paymentStatus: 3,
  //       discount: 0,
  //       ...(!['SER'].includes(getAccountType())
  //         ? { accountRemarks: this.state.remarks }
  //         : { serviceRemarks: this.state.remarks })
  //     },
  //     errorPolicy: 'all'
  //   })

  //   this.setState({
  //     invoiceAmount: '',
  //     paymentStatus: '',
  //     discount: '',
  //     remarks: ''
  //   })

  //   this.props.history.push({
  //     pathname: '/home/manage/admin/InvoiceDetails'
  //   })
  // }

  // downloadPdf = async () => {
  //   this.setState({ isDownloading: true })
  //   const isInvoice = [3, 4].includes(this.state.piInfo.paymentStatus)
  //   const { data } = await this.props.client.query({
  //     query: GET_PDF_DOWNLOAD_LINK,
  //     variables: {
  //       id: parseInt(this.id, 10),
  //       isInvoice
  //     },
  //     errorPolicy: 'all'
  //   })

  //   if (data && data.getInvoiceDownloadDetails) {
  //     const res = await axios({
  //       url: data.getInvoiceDownloadDetails,
  //       method: 'GET',
  //       headers: { Accept: 'application/pdf' },
  //       responseType: 'blob' // important
  //     })

  //     FileSaver.saveAs(new Blob([res.data]), 'Invoice.pdf')
  //   }
  //   this.setState({ isDownloading: false })
  // }

  calculateBalance = perticularName => {
    const {
      piInfo: { billingDetails }
    } = this.state
    if (perticularName === 'hardwarePaymentMade') {
      if (billingDetails.hardwareBillDetails) {
        const { amountToBePaidGST } = billingDetails.hardwareBillDetails
        const { hardwarePaymentMade } = this.state
        this.setState({
          hardwareBalance: amountToBePaidGST - hardwarePaymentMade
        })
      }
    } else if (perticularName === 'softwarePaymentMade') {
      if (billingDetails.softwareBillDetails) {
        const { amountToBePaidGST } = billingDetails.softwareBillDetails
        const { softwarePaymentMade } = this.state
        this.setState({
          softwareBalance: amountToBePaidGST - softwarePaymentMade
        })
      }
    } else if (perticularName === 'accessoryPaymentMade') {
      if (billingDetails.accessoryBillDetails) {
        const { amountToBePaidGST } = billingDetails.accessoryBillDetails
        const { accessoryPaymentMade } = this.state
        this.setState({
          accessoryBalance: amountToBePaidGST - accessoryPaymentMade
        })
      }
    } else {
      const { amountToBePaidGST } = billingDetails.simBillDetails
      const { simPaymentMade } = this.state
      this.setState({
        simBalance: amountToBePaidGST - simPaymentMade
      })
    }
  }

  handlePaymentMade = name => event => {
    console.log('handlepayment made', name)
    this.setState({ [name]: event.target.value }, () => {
      this.calculateBalance(name)
      this.handleTotalAmountPaid()
    })
  }

  handleExpectedDateChange = name => date => {
    this.setState({ [name]: date }, () => {})
  }

  handleRemarksChange = name => event => {}

  paymentModeAndModeValidation = () => {
    const { totalAmountPaid, paymentMode } = this.state
    if (totalAmountPaid > 0 && paymentMode) {
      this.setState({ paymentMadeFieldValidation: true })
    } else {
      this.setState({ paymentMadeFieldValidation: false })
    }
  }

  handleTotalAmountPaid = () => {
    let total = 0
    const {
      hardwarePaymentMade,
      softwarePaymentMade,
      accessoryPaymentMade,
      simPaymentMade
    } = this.state
    total =
      parseInt(hardwarePaymentMade, 10) +
      parseInt(softwarePaymentMade, 10) +
      parseInt(accessoryPaymentMade, 10) +
      parseInt(simPaymentMade, 10)
    this.setState({ totalAmountPaid: total }, () => {
      this.paymentModeAndModeValidation()
    })
  }

  handleChangePaymentType = event => {
    this.setState({ paymentMode: event.target.value }, () => {
      this.paymentModeAndModeValidation()
    })
  }

  handleChangeReferenceNumber = event => {
    // console.log('event', event.target.value)
    this.setState({ referenceNumber: event.target.value })
    // console.log('referenceNumber', this.state.referenceNumber)
  }

  handleChangeBankName = event => {
    this.setState({ bankName: event.target.value })
  }

  handleAccountRemarksChange = event => {
    this.setState({ accountRemarks: event.target.value })
  }

  getClientPIInfo = async () => {
    const { data } = await this.props.client.query({
      query: GET_PI_INFO,
      variables: {
        id: parseInt(this.id, 10)
      },
      fetchPolicy: 'network-only'
    })
    if (data.getPIAndInvoiceDetail) {
      this.setState(
        {
          piInfo: data.getPIAndInvoiceDetail
        },
        () => {
          console.log('piInfo', this.state.piInfo)
          this.setInitialData()
          this.getPaymentStatusValue()
        }
      )
    }
  }

  setInitialData = () => {
    const { piInfo } = this.state
    if (piInfo.paymentMasterDetails) {
      this.setState({
        paymentId: piInfo.paymentMasterDetails.id,
        paymentStatus: piInfo.paymentMasterDetails.paymentStatus
      })
    }
    if (piInfo.billingDetails) {
      const {
        hardwareBillDetails,
        softwareBillDetails,
        accessoryBillDetails,
        simBillDetails
      } = piInfo.billingDetails

      if (hardwareBillDetails) {
        this.setState({
          hardwareBalance: hardwareBillDetails.amountToBePaidGST
        })
      }
      if (softwareBillDetails) {
        this.setState({
          softwareBalance: softwareBillDetails.amountToBePaidGST
        })
      }
      if (accessoryBillDetails) {
        this.setState({
          accessoryBalance: accessoryBillDetails.amountToBePaidGST
        })
      }
      if (simBillDetails) {
        this.setState({ simBalance: simBillDetails.amountToBePaidGST })
      }
    }
  }

  mapToArray = data => {
    console.log('invoice data', data)
    const { paymentMasterDetails, paymentHitoryDetails } = data
    const mappedArray = paymentHitoryDetails.reduce((acc, item) => {
      const tableData = []
      tableData.push(paymentMasterDetails.invoiceId)

      item.paidMoney >= 0
        ? tableData.push(item.paidMoney)
        : tableData.push('N/A')

      item.paymentMode
        ? tableData.push(item.paymentMode)
        : tableData.push('N/A')

      item.referenceNumber
        ? tableData.push(item.referenceNumber)
        : tableData.push('N/A')

      item.bank ? tableData.push(item.bank) : tableData.push('N/A')

      /* eslint-disable indent */
      item.createdAt
        ? tableData.push(moment.unix(parseInt(item.createdAt, 10)).format('L'))
        : tableData.push('N/A')
      /* eslint-enable indent */

      item.accountRemarks
        ? tableData.push(item.accountRemarks)
        : tableData.push('N/A')

      acc.push(tableData)
      return acc
    }, [])
    this.setState(
      {
        allInvoiceData: mappedArray
      },
      () => {
        console.log('all Invoive data', this.state.allInvoiceData)
      }
    )
  }

  getPIandInvoice = async () => {
    const { data, loading, error } = await this.props.client.query({
      query: GET_PI_AND_INVOICE,
      variables: {
        id: parseInt(this.props.match.params.id, 10)
      },
      fetchPolicy: 'network-only'
    })

    console.log('all PI data', data)
    if (data && data.getPIAndInvoiceDetail) {
      this.mapToArray(data.getPIAndInvoiceDetail)
    }
  }

  componentDidMount() {
    this.getClientPIInfo()
    this.getPIandInvoice()
  }

  getPaymentStatusValue = () => {
    if (this.state.piInfo) {
      console.log(
        'payment status',
        this.state.piInfo.paymentMasterDetails.paymentStatus
      )
      switch (this.state.piInfo.paymentMasterDetails.paymentStatus) {
        case 0:
          this.setState({
            paymentStatusShow: 'Unpaid'
          })
          break
        case 1:
          this.setState({
            paymentStatusShow: 'Pending for approval'
          })
          break
        case 2:
          this.setState({
            paymentStatusShow: 'Subscription approved'
          })
          break
        case 3:
          this.setState({
            paymentStatusShow: 'Subscription Rejected'
          })
          break
        case 4:
          this.setState({
            paymentStatusShow: 'Full payment'
          })
          break
        case 5:
          this.setState({
            paymentStatusShow: 'On hold'
          })
          break
        case 6:
          this.setState({
            paymentStatusShow: 'Partial payment'
          })
          break
        default:
          this.setState({
            paymentStatusShow: 'N/A'
          })
          break
      }
    }
  }

  render() {
    const { classes } = this.props
    const { piInfo, paymentMadeFieldValidation, allInvoiceData } = this.state
    return (
      <Fragment>
        <div className={classes.root}>
          <Grid item className={classes.gridItemHorizontal}>
            <Button
              variant="outlined"
              color="secondary"
              className={classes.button}
              onClick={() => this.props.history.goBack()}
            >
              <ArrowBackIcon className={classes.iconSmall} />
            </Button>
          </Grid>
          <Grid container justify="space-between" alignItems="center">
            <Grid item>
              <Typography variant="display1" gutterBottom>
                Invoice Details
              </Typography>
            </Grid>
            <Grid item>
              <Grid container spacing={16}>
                {/* <Grid item>
                  <Button
                    variant="outlined"
                    onClick={() => this.downloadPdf(false)}
                  >
                    {this.state.isDownloading ? (
                      <CircularProgress size={24} />
                    ) : (
                      'Download PI'
                    )}
                  </Button>
                </Grid> */}
                {[3, 4].includes(this.state.piInfo.paymentStatus) && (
                  <Grid item>
                    <Button
                      variant="raised"
                      color="primary"
                      onClick={() => this.downloadPdf(true)}
                    >
                      {this.state.isDownloading ? (
                        <CircularProgress size={24} />
                      ) : (
                        'Download Invoice'
                      )}
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Card className={classes.card} raised>
              <CardHeader title="Client Details" />
              <CardContent>
                <Grid container spacing={16}>
                  <Grid item xs={3}>
                    <Typography variant="body1" color="textSecondary">
                      Client Name
                    </Typography>
                    <Typography variant="body2">
                      {piInfo.clientDetails && piInfo.clientDetails.clientName}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={16}>
                  <Grid item xs={4}>
                    <Typography variant="body1" color="textSecondary">
                      Invoice Number
                    </Typography>
                    <Typography variant="body2">
                      {piInfo.paymentMasterDetails &&
                        piInfo.paymentMasterDetails.invoiceId}
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="body1" color="textSecondary">
                      Payment Status
                    </Typography>
                    <Typography variant="body2">
                      {piInfo.paymentMasterDetails &&
                        this.state.paymentStatusShow}
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="body1" color="textSecondary">
                      Total Subscriptions
                    </Typography>
                    <Typography variant="body2">
                      {piInfo.noOfSubscriptions && piInfo.noOfSubscriptions
                        ? piInfo.noOfSubscriptions
                        : 'N/A'}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container spacing={16}>
                  {/* <Grid item xs={4}>
                    <Typography variant="body1" color="textSecondary">
                      Total Devices
                    </Typography>
                    <Typography variant="body2">
                      {piInfo.ClientDetail && piInfo.ClientDetail.totalDevices}
                    </Typography>
                  </Grid> */}
                  <Grid item xs={4}>
                    <Typography variant="body1" color="textSecondary">
                      Pending amount(incl GST)
                    </Typography>
                    <Typography variant="body2">
                      &#8377;{' '}
                      {piInfo.clientDetails &&
                        piInfo.billingDetails.totalAmountToBePaidGST}
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="body1" color="textSecondary">
                      Invoice Amount (Incl GST)
                    </Typography>
                    <Typography variant="body2">
                      &#8377;{' '}
                      {piInfo.paymentMasterDetails &&
                        piInfo.paymentMasterDetails.invoiceAmountWithGST}
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="body1" color="textSecondary">
                      Sim Wallet
                    </Typography>
                    <Typography variant="body2">
                      &#8377;{' '}
                      {piInfo.clientDetails && piInfo.clientDetails.simWallet}
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="body1" color="textSecondary">
                      software Wallet
                    </Typography>
                    <Typography variant="body2">
                      &#8377;{' '}
                      {piInfo.clientDetails && piInfo.clientDetails.wallet}
                    </Typography>
                  </Grid>
                  {/* <Grid item xs={12} md={6}>
                    <Typography variant="body1" color="textSecondary">
                      Service Remarks
                    </Typography>
                    <Typography variant="body2">
                      {piInfo.paymentMasterDetails &&
                      piInfo.paymentMasterDetails.serviceRemarks
                        ? piInfo.paymentMasterDetails.serviceRemarks
                        : 'N/A'}
                    </Typography>
                  </Grid> */}

                  {(this.state.piInfo.paymentStatus === 3 ||
                    this.state.piInfo.paymentStatus === 4) && (
                    <Grid item xs={12} md={6}>
                      <Typography variant="body1" color="textSecondary">
                        Account Remarks
                      </Typography>
                      <Typography variant="body2">
                        {this.state.piInfo.accountRemarks || '-'}
                      </Typography>
                    </Grid>
                  )}
                  {this.state.piInfo.paymentStatus === 4 && (
                    <Fragment>
                      <Grid item xs={12} md={4}>
                        <Typography variant="body1" color="textSecondary">
                          Discount
                        </Typography>
                        <Typography variant="body2">
                          &#8377;{' '}
                          {this.state.piInfo.totalPI -
                            this.state.piInfo.totalInvoice}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Typography variant="body1" color="textSecondary">
                          Final amount
                        </Typography>
                        <Typography variant="body2">
                          &#8377; {this.state.piInfo.totalInvoice}
                        </Typography>
                      </Grid>
                    </Fragment>
                  )}
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <br />

          {/* Billing Details Module */}
          {/* eslint-disable indent */}
          {['ACC'].includes(getAccountType()) &&
            piInfo.paymentMasterDetails &&
            [0, 6].includes(piInfo.paymentMasterDetails.paymentStatus) && (
              <Fragment>
                <BillingDetailsProformaInvoice
                  piInfoData={piInfo}
                  hardwarePaymentMade={this.state.hardwarePaymentMade}
                  paymentStatus={this.state.paymentStatus}
                  softwarePaymentMade={this.state.softwarePaymentMade}
                  accessoryPaymentMade={this.state.accessoryPaymentMade}
                  simPaymentMade={this.state.simPaymentMade}
                  hardwareBalance={this.state.hardwareBalance}
                  softwareBalance={this.state.softwareBalance}
                  accessoryBalance={this.state.accessoryBalance}
                  simBalance={this.state.simBalance}
                  hardwareRemarks={this.state.hardwareRemarks}
                  softwareRemarks={this.state.softwareRemarks}
                  accessoryRemarks={this.state.accessoryRemarks}
                  simRemarks={this.state.simRemarks}
                  expectedHardwareDueDate={this.state.expectedHardwareDueDate}
                  expectedSoftwareDueDate={this.state.expectedSoftwareDueDate}
                  expectedAccessoryDueDate={this.state.expectedAccessoryDueDate}
                  expectedSimsDueDate={this.state.expectedSimsDueDate}
                  handlePaymentMade={this.handlePaymentMade}
                  handleRemarksChange={this.handleRemarksChange}
                  handleExpectedDateChange={this.handleExpectedDateChange}
                />
              </Fragment>
            )}
          <br />

          {/* Payment History */}
          {/* eslint-disable */}
          <Grid item xs={12}>
            {['ACC'].includes(getAccountType()) &&
              piInfo.paymentMasterDetails &&
              [0, 6, 4].includes(piInfo.paymentMasterDetails.paymentStatus) && (
                <Card raised>
                  <CardContent>
                    <CardHeader
                      className={classes.cardAction}
                      title="Payment History"
                    />
                    {/* Credit Note Section */}
                    <Grid container justify="space-between">
                      {/* Column Header Section  */}
                      <MuiThemeProvider theme={this.getMuiTheme()}>
                        <div style={{ width: '100%' }}>
                          <MUIDataTable
                            data={allInvoiceData}
                            columns={columns}
                            options={this.options}
                          />
                        </div>
                      </MuiThemeProvider>
                    </Grid>
                  </CardContent>
                </Card>
              )}
          </Grid>
          <br />

          {/* Record payment Section */}
          {['ACC'].includes(getAccountType()) &&
            piInfo.paymentMasterDetails &&
            [0, 6].includes(piInfo.paymentMasterDetails.paymentStatus) && (
              <Grid item xs={12}>
                <Card className={classes.card} raised>
                  <CardHeader title="Record Payment" />
                  <CardContent>
                    <Grid container spacing={16}>
                      <Grid item xs={12}>
                        <FormControl className={classes.formControl}>
                          <InputLabel id="payment-helper">
                            Payment Type
                          </InputLabel>
                          <Select
                            value={this.state.paymentMode}
                            onChange={this.handleChangePaymentType}
                            className={classes.selectStyle}
                          >
                            <MenuItem value="">
                              <em>None</em>
                            </MenuItem>
                            <MenuItem value={'CASH'}>Cash</MenuItem>
                            <MenuItem value={'ONLINE'}>Online</MenuItem>
                            <MenuItem value={'CHEQUE'}>Cheque</MenuItem>
                            <MenuItem value={'DD'}>DD</MenuItem>
                          </Select>
                          {/* <FormHelperText>Some important helper text</FormHelperText> */}
                        </FormControl>
                      </Grid>

                      {paymentOption.includes(this.state.paymentMode) && (
                        <Grid item xs={12}>
                          <PaymentMethod
                            paymentThrough={this.state.paymentMode}
                            handleChangereferenceNumber={
                              this.handleChangeReferenceNumber
                            }
                            handleChangeBankName={this.handleChangeBankName}
                            handleChangePaidMoney={this.handleChangePaidMoney}
                            // paidMoney={this.state.paidMoney}
                            referenceNumber={this.state.referenceNumber}
                            bankName={this.state.bankName}
                          />
                        </Grid>
                      )}

                      <Grid item xs={12}>
                        <TextField
                          multiline
                          rows={2}
                          label="Remarks"
                          variant="contained"
                          onChange={this.handleAccountRemarksChange}
                          value={this.state.accountRemarks}
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                  <CardActions>
                    <Button
                      variant="contained"
                      color="secondary"
                      classes={{ root: classes.redButton }}
                      onClick={this.handleCancel}
                    >
                      Cancel
                    </Button>
                    <Button
                      disabled={
                        !paymentMadeFieldValidation ||
                        this.state.saveBtnDisabled
                      }
                      variant="contained"
                      color="secondary"
                      type="submit"
                      onClick={this.handleSave}
                    >
                      Save
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            )}
        </div>
        {/* eslint-enable indent */}
      </Fragment>
    )
  }
}

export default withStyles(style)(
  withSharedSnackbar(withApollo(CreateProformaInvoice))
)



// WEBPACK FOOTER //
// ./src/components/Pages/Billing/CreateProformaInvoice/index.jsx